export default defineNuxtPlugin(() => {
  const fromEntries = entries => entries.reduce((object, [key, value]) => {
    object[key] = value
    return object
  }, {})
  if (!Object.fromEntries) {
    Object.fromEntries = fromEntries
  }
})
